export enum PencilIconSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
}

export default function PencilIcon({
  size = PencilIconSize.MEDIUM,
}: {
  readonly size?: PencilIconSize | undefined;
}) {
  const classes: Record<PencilIconSize, string> = {
    [PencilIconSize.SMALL]: "tw-w-4 tw-h-4",
    [PencilIconSize.MEDIUM]: "tw-w-5 tw-h-5",
  };

  return (
    <svg
      className={`${classes[size]} tw-flex-shrink-0`}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
